import React from "react";

import { Button } from "antd";

import {
  TestConnectionContainer,
} from "./EntrataTestConnection.styled";

/**
 * Props interface for EntrataTestConnection component
 */
interface RentManagerTestConnectionProps {
  /** Callback function triggered when test connection button is clicked */
  onTestConnection: () => void;
  /** Boolean indicating if connection test is currently in progress */
  isTestingConnection: boolean;
  /** Result object containing success status and message from connection test */
  connectionTestResult: {
    success: boolean;
    message: string;
    data: [];
  } | null;
  /** Boolean to disable the test connection button */
  disabled?: boolean;
}

/**
 * RentManagerTestConnection Component
 *
 * A reusable component that provides test connection functionality for Rent Manager integration.
 * Displays a test connection button and shows feedback based on the connection test result.
 *
 * @param props - Component props
 * @returns JSX element containing test connection UI
 */
const RentManagerTestConnection: React.FC<RentManagerTestConnectionProps> = ({
  onTestConnection,
  isTestingConnection,
  connectionTestResult,
  disabled = false,
}) => {


  return (
    <TestConnectionContainer>
      <div className="entrata-test-connection">
        <Button
          type="default"
          data-testid="test-connection-btn"
          className="test-connection-button"
          disabled={disabled || isTestingConnection}
          loading={isTestingConnection}
          onClick={onTestConnection}
          size="large"
        >
          {isTestingConnection ? "Checking for available Locations…" : connectionTestResult?.success ? "Refresh Locations" : "Fetch Locations"}
        </Button>
        
        {(connectionTestResult?.success === true && connectionTestResult.data.length === 0) && <p className="test-connection-hint">
            Once your Rent Manager access is updated, your Locations will appear here automatically.
        </p>}
      </div>
    </TestConnectionContainer>
  );
};

export default RentManagerTestConnection;
